import { render } from "./FinancialDetails.vue?vue&type=template&id=f8a2a876"
import script from "./FinancialDetails.vue?vue&type=script&lang=js"
export * from "./FinancialDetails.vue?vue&type=script&lang=js"

import "./FinancialDetails.vue?vue&type=style&index=0&id=f8a2a876&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__